export default __webpack_public_path__ + "static/media/game.7f5c0e6d.jpg";